<!-- MEDICO -->
<div *ngIf="(usuario.typ_id == 1)" class="card"
  [ngClass]="{'border-card': data.tel_doc_app_boo_is_ondemand == false, 'border-card-ondemand': data.tel_doc_app_boo_is_ondemand == true}">

  <div class="card-body row" style="padding: 5%; gap: 20px;">
    <div class="col-12 p-0 d-flex">
      <app-profile-img [img]="data.img" [doctorName]="data.nombre_paciente"
        [doctorLastName]="data.apellido_paterno_paciente" [color]="getAppointmentColor()">
      </app-profile-img>

      <div class="ml-3 align-self-center">
        <p class="card-text m-0 p-0 appt-date">
          {{ data.date[0] }} {{ data.date[1] }}
        </p>

        <p class="card-text m-0 p-0">
          {{ data.spec }}
        </p>

        <p class="card-text m-0 p-0">
          {{ data.nombre_paciente }} {{ data.apellido_paterno_paciente }} {{ data.apellido_materno_paciente }}
        </p>
      </div>
    </div>

    <div class="col-12" style="display: flex; flex-direction: column; justify-content: flex-end;">
      <div class="row p-0">
        <div class="col-6 p-0">
          <button *ngIf="puedeMostrarIngresoConsulta()" type="button" class="btn btn-primary mr-auto"
            [disabled]="!puedeEntrarConsulta()" [ngClass]="{'btn-ondemand': data.tel_doc_app_boo_is_ondemand == true}"
            (click)="goVideoConsultaMedico()">
            Ir a la consulta
          </button>
        </div>

        <div class="col-6" style="display: flex; align-items: center; justify-content: flex-end;">
          <p *ngIf="data.tel_doc_app_boo_is_ondemand == false" class="card-text flag-helper appt-date">
            {{ data.confirmedFlag ? 'Confirmada' : 'Reservada' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- PACIENTE -->
<div *ngIf="(usuario.typ_id == 2 && data.acompanante == false && data.consulta.tel_doc_app_boo_is_ondemand == false)"
  class="card"
  [ngClass]="{'border-card': data.consulta.tel_doc_app_boo_is_ondemand == false, 'border-card-ondemand': data.consulta.tel_doc_app_boo_is_ondemand == true}">

  <div class="card-header p-0">
    <div class="row p-0">
      <span *ngIf="data.consulta.tel_doc_app_boo_is_ondemand == false"
        class="badge badge-primary align-self-start badge-color">
        Agendamiento
      </span>

      <span *ngIf="data.consulta.tel_doc_app_boo_is_ondemand == true"
        class="badge badge-primary align-self-start badge-color-ondemand">
        Atención Inmediata
      </span>

      <app-popover *ngIf="options_bool" [color]="popoverColor">

        <a *ngIf="puedeConfirmarAsistencia()" class="pointer" (click)="mostrarModal('confirmar')">
          <p>Confirmar asistencia</p>
        </a>

        <a data-toggle="modal" class="pointer" (click)="modificarConsulta(data)">
          <p>Modificar consulta</p>
        </a>

        <a data-toggle="modal" class="pointer" (click)="detallesConsulta(data)">
          <p>Detalle de mi consulta</p>
        </a>

        <a class="pointer" (click)="mostrarModal('salir')">
          <p>Anular consulta</p>
        </a>

      </app-popover>
    </div>
  </div>

  <div class="card-body row">
    <div class="col-12 p-0 d-flex">
      <app-profile-img [img]="data.consulta.att_path" [doctorName]="data.doctorName"
        [doctorLastName]="data.doctorLastName" [color]="getAppointmentColor()">
      </app-profile-img>

      <div class="ml-3 align-self-center">
        <p class="card-text m-0 p-0 appt-date" style="font-weight: 700; color: #171994;">
          {{ data.date[0] }}
        </p>

        <p class="card-text m-0 p-0 appt-date" style="font-weight: 700; color: #171994;">
          {{ data.date[1] }}
        </p>
      </div>
    </div>

    <div class="col-12 p-0">
      <p class="card-text doc-data" style="padding: 2% 0;">
        {{ data.doctorName }} {{ data.doctorLastName }} - {{ data.spec }}
      </p>
    </div>

    <div class="col-12" style="margin-top: auto;">
      <div class="row p-0">
        <div class="col-6 p-0">
          <div style="width: 100%;">

            <button *ngIf="puedeMostrarSalaEspera()" type="button" class="btn btn-primary mr-auto"
              [disabled]="!puedeEntrarSalaEspera()" (click)="goLobby()">
              Ir a sala de espera
            </button>

            <button *ngIf="puedeConfirmarAsistencia()" type="button" class="btn btn-secondary mr-auto"
              (click)="mostrarModal('confirmar')">
              Confirmar asistencia
            </button>

          </div>
        </div>

        <div class="col-6 p-0" style="display: flex; align-items: center; justify-content: flex-end;">
          <p class="card-text flag-helper" style="text-align: end; color: #316AD8">
            {{ data.confirmedFlag ? 'Confirmada' : 'Reservada' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ACOMPAÑANTE -->
<div *ngIf="(usuario.typ_id == 2 && data.acompanante)" class="card border-card h-100 p-0 m-0">
  <div class="card-header p-0">
    <div class="row p-0">
      <span class="badge badge-primary align-self-start badge-color">
        Agendamiento
      </span>

      <app-popover *ngIf="options_bool" style="color: transparent;" class="popover-disabled" aria-disabled="true">

        <a data-toggle="modal" class="pointer" (click)="modificarConsulta(data)">
          <p>Modificar consulta</p>
        </a>

        <a data-toggle="modal" class="pointer" (click)="detallesConsulta(data)">
          <p>Detalle de mi consulta</p>
        </a>

        <a class="pointer" (click)="mostrarModal('salir')">
          <p>Anular consulta</p>
        </a>

      </app-popover>
    </div>
  </div>

  <div class="card-body row">
    <div class="col-12 p-0 d-flex">
      <app-profile-img [img]="data.consulta.att_path" [doctorName]="data.doctorName"
        [doctorLastName]="data.doctorLastName" [color]="getAppointmentColor()">
      </app-profile-img>

      <div class="ml-3 align-self-center">
        <p class="card-text m-0 p-0 appt-date" style="font-weight: 700; color: #171994;">
          {{ data.date[0] }}
        </p>

        <p class="card-text m-0 p-0 appt-date" style="font-weight: 700; color: #171994;">
          {{ data.date[1] }}
        </p>
      </div>
    </div>

    <div class="col-12 p-0">
      <p class="card-text doc-data" style="padding: 2% 0;">
        {{ data.doctorName }} {{ data.doctorLastName }} - {{ data.spec }}
      </p>
    </div>

    <div class="col-12" style="margin-top: auto;">
      <div class="row p-0">
        <div class="col-6 p-0">
          <div style="width: 100%;">

            <button *ngIf="puedeMostrarSalaEspera()" type="button" class="btn btn-primary mr-auto"
              [disabled]="!puedeEntrarSalaEspera()" (click)="goLobbyAcomp()">
              Ir a sala de espera
            </button>

          </div>
        </div>

        <div class="col-6 p-0" style="display: flex; align-items: center; justify-content: flex-end;">
          <p class="card-text flag-helper" style="text-align: end; color: #316AD8">
            {{ data.confirmedFlag ? 'Confirmada' : 'Reservada' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Bootstrap antiguo -->
<div class="modal fade confirmarAppoModal backdrop-contrast" id="confirmarAppoModal{{data.id_consulta}}" tabindex="-1"
  role="dialog" aria-labelledby="confirmarAppoModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h2 style="text-align: center;">¿Deseas confirmar tu asistencia?</h2>
      </div>

      <div class="modal-body">
        <p class="hora">{{ data.date[0] }} {{ data.date[1] }}</p>
        <p class="detalle">{{ data.doctorName }} {{ data.doctorLastName }} - {{ data.spec }}</p>
      </div>

      <div class="modal-footer">
        <div style="width: 50%;">
          <button type="button" class="btn btn-volver" style="float: left;" data-dismiss="modal">
            <div style="margin: auto;">Volver atrás</div>
          </button>
        </div>

        <div style="width: 50%;">
          <button class="btn btn-confirmar" data-dismiss="modal" style="float: right;" (click)="confirmAppt()">
            <div style="margin: auto;">Confirmar</div>
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Modal de confirmación asistencia estilo nuevo -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'confirmar'" (click)="cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">¿Deseas confirmar tu asistencia?</h2>

    <p class="modal-reason text-center">{{ data.date[0] }} {{ data.date[1] }}</p>
    <p class="modal-reason text-center">{{ data.doctorName }} {{ data.doctorLastName }} - {{ data.spec }}</p>

    <div class="buttons-box row mt-4">
      <div class="col">
        <button mat-button class="btn-secondary" (click)="cerrarModal()">
          <p style="font-weight: 600; margin: 5px; font-size: 14px;">Volver atrás</p>
        </button>
      </div>

      <div class="col">
        <button mat-raised-button class="btn-primary-cancel" (click)="confirmAppt()">
          <p style="font-weight: 600; margin: 5px;">Confirmar</p>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal confirmación principal anulación -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'salir'" (click)="cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">¿Deseas anular tu consulta agendada?</h2>

    <p class="modal-reason">{{ cancelMsg1 }}</p>
    <p class="modal-reason">{{ cancelMsg2 }}</p>
    <p class="modal-reason2">Selecciona el motivo por el cual estás anulando:</p>

    <form [formGroup]="anularConsultaForm">
      <div class="form-group">
        <select class="form-control" formControlName="motivo">
          <option value="" disabled selected>Selecciona un motivo</option>
          <option *ngFor="let razon of cancelReason" [value]="razon.id_reason">
            {{ razon.reason_name }}
          </option>
        </select>
      </div>
    </form>

    <div class="buttons-box row mt-3">
      <div class="col">
        <button mat-button class="btn-secondary" style="line-height: 36px;" (click)="cerrarModal()">
          <p class="m-0" style="font-weight: 600;">Volver</p>
        </button>
      </div>

      <div class="col">
        <button mat-raised-button class="btn-primary-cancel"
          style="line-height: 36px; border: 2px solid #0e0087 !important;" [disabled]="anularConsultaForm.invalid"
          (click)="mostrarModalConfirmacion()">
          <p class="m-0" style="font-weight: 600;">Aceptar</p>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Segundo modal de confirmación anulación -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'confirmacionFinal'" (click)="!isCanceling && cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">Confirmación de anulación</h2>

    <p class="modal-reason">
      Al confirmar esta acción, se anulará de forma definitiva tu consulta agendada.
    </p>

    <div class="buttons-box row mt-3">
      <div class="col">
        <button mat-button class="btn-secondary" style="line-height: 36px;" (click)="cerrarModal()"
          [disabled]="isCanceling">
          <p class="m-0" style="font-weight: 600;">Cancelar</p>
        </button>
      </div>

      <div class="col">
        <button mat-raised-button class="btn-primary-cancel"
          style="line-height: 36px; border: 2px solid #0e0087 !important;" (click)="anularConsultaConfirmada()"
          [disabled]="isCanceling">
          <p class="m-0" style="font-weight: 600;">
            {{ isCanceling ? 'Anulando...' : 'Aceptar' }}
          </p>
        </button>
      </div>
    </div>
  </div>
</div>